import { Directive } from "@angular/core";

@Directive({
    selector: '[nav-content]',
    standalone: false
})
export class LayeredNavContentDirective { }
